import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-accountability-data-reporting',
  imports: [PillarPagesTemp],
  templateUrl: './accountability-data-reporting.html',
  styleUrl: './accountability-data-reporting.scss',
})
export class AccountabilityDataReporting {

}
